// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__D2aCp","option":"styles_option__24_QH","selected":"styles_selected__vZwII"};